// extracted by mini-css-extract-plugin
export default {"root":"tweet-link_root__a6wWt"};